module.exports = __webpack_public_path__ + "img/mt.b127219b.svg";